var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10H8.5C8.2 10 8 9.8 8 9.5C8 9.2 8.2 9 8.5 9H16L14 11V10ZM10 6H15.5C15.8 6 16 6.2 16 6.5C16 6.8 15.8 7 15.5 7H8L10 5V6ZM13.5 11C13.8 11 14 11.2 14 11.5V13.5C14 14.3 13.3 15 12.5 15H2.5C1.7 15 1 14.3 1 13.5V2.5C1 1.7 1.7 1 2.5 1H12.5C13.3 1 14 1.7 14 2.5V4.5C14 4.8 13.8 5 13.5 5C13.2 5 13 4.8 13 4.5V2.5C13 2.2 12.8 2 12.5 2H2.5C2.2 2 2 2.2 2 2.5V13.5C2 13.8 2.2 14 2.5 14H12.5C12.8 14 13 13.8 13 13.5V11.5C13 11.2 13.2 11 13.5 11Z",
    fill: "#000022",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.3b48f96543d67a1c331646d3c3008e6d.svg";
export { ForwardRef as ReactComponent };